class Auth {
    sessionToken
    expiresAt

    constructor() {
        // Initialize from persistent storage if available
        try {
            const storedToken = localStorage.getItem('sessionToken')
            const storedExpiresAt = localStorage.getItem('expiresAt')
            const expires = storedExpiresAt ? parseInt(storedExpiresAt, 10) : null

            if (storedToken && expires && !Number.isNaN(expires) && Date.now() < expires) {
                this.sessionToken = storedToken
                this.expiresAt = expires
            } else {
                this.sessionToken = null
                this.expiresAt = null
                // Clean up any stale values
                localStorage.removeItem('sessionToken')
                localStorage.removeItem('expiresAt')
            }
        } catch (e) {
            // Fallback to in-memory only if localStorage is unavailable
            this.sessionToken = null
            this.expiresAt = null
        }
    }

    isAuth() {
        const valid = this.sessionToken != null && (this.expiresAt != null && Date.now() < this.expiresAt)
        if (!valid) {
            // Ensure we clean up expired credentials
            try {
                localStorage.removeItem('sessionToken')
                localStorage.removeItem('expiresAt')
            } catch (_) {
                // Intentionally ignore storage errors (e.g., private mode or disabled storage)
            }
        }
        return valid
    }

    setAuth(token, expiresAt) {
        this.sessionToken = token
        this.expiresAt = expiresAt
        try {
            localStorage.setItem('sessionToken', token)
            localStorage.setItem('expiresAt', String(expiresAt))
        } catch (_) {
            // Intentionally ignore storage errors (e.g., private mode or disabled storage)
        }
    }

    logout() {
        // Clear in-memory and persistent auth data
        this.sessionToken = null
        this.expiresAt = null
        try {
            localStorage.removeItem('sessionToken')
            localStorage.removeItem('expiresAt')
            // Optionally also clear any UI state like lastActiveMenu
            localStorage.removeItem('lastActiveMenu')
        } catch (_) {
            // Intentionally ignore storage errors
        }
    }
}

const auth = new Auth()

export {auth}
